var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-list-item',[_c('md-icon',[_vm._v("whatshot")]),_vm._v(" "),_c('span',[_vm._v("Tags")]),_vm._v(" "),_c('md-list-expand',_vm._l((_vm.tags),function(tag,index){return _c('md-chip',{key:index,attrs:{"md-editable":""}},[_c('span',{on:{"click":function($event){_vm.changed(tag)}}},[_vm._v(_vm._s(tag))])])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9655a6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tagsFilter.vue
// module id = ewz8
// module chunks = 1